/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { HTTPRequestFactory } from "common/utils/network"
import { getApiUrl, getTroyUrl } from "constants/domain"
import { logout } from "./authentication"
import { sessionInfo } from "./session"
import { redirectToLoginPage } from "./uri"
import { emitSessionError } from "./sessionError"
import { isWebview } from "./webview"

export const http401UnauthorizedHandler = () => {
  // Inside the native app webview the portal has no login of its own: the app
  // owns the session and injects the token (cookie). Sending the merchant to
  // the portal login page there is a dead end, so raise a session error — the
  // app shell renders a retryable error screen instead.
  if (isWebview()) {
    emitSessionError("http401")
    return
  }
  logout()
  redirectToLoginPage()
}

const pathRewriter = (path: string): string => {
  return path.replace(
    /(\/v\d+?)/,
    (replacement: string) =>
      `${replacement}/${sessionInfo.userCurrentCountryCode}`,
  )
}

export const httpRequest = new HTTPRequestFactory({
  jwtAccessible: sessionInfo,
  prefix: "foodtroy",
  http401UnauthorizedHandler,
  pathRewriter,
})

export const foodMerchantHttpRequest = new HTTPRequestFactory({
  jwtAccessible: sessionInfo,
  prefix: "food/merchant",
  apiHostGetter: getApiUrl,
})

export const mexInsightsHttpRequest = new HTTPRequestFactory({
  jwtAccessible: sessionInfo,
  prefix: "mex-insights",
  apiHostGetter: getTroyUrl,
})

export const delvPlatfromHttpRequest = new HTTPRequestFactory({
  jwtAccessible: sessionInfo,
  prefix: "delvplatformapi/merchant",
  apiHostGetter: getApiUrl,
})
